
import React from "react";
import { Button } from "@/components/ui/button";
import { MapPin, Mail, Clock, Phone, Users, Award } from "lucide-react";
import { Link } from "react-router-dom";

const ContactInfo: React.FC = () => {
  return (
    <div className="space-y-8">
      <div className="bg-gradient-to-br from-fabre-green to-fabre-darkgreen p-8 rounded-2xl text-white">
        <h2 className="text-2xl font-heading font-bold mb-6 flex items-center">
          <Users className="h-6 w-6 mr-3" />
          Nos Coordonnées
        </h2>
        
        <div className="space-y-6">
          <div className="flex items-start group">
            <div className="w-12 h-12 rounded-xl bg-white/20 flex items-center justify-center mr-4 flex-shrink-0 group-hover:bg-white/30 transition-colors">
              <MapPin className="h-5 w-5 text-white" />
            </div>
            <div>
              <h3 className="font-heading font-semibold mb-1">Siège Social</h3>
              <p className="text-white/90 leading-relaxed">
                12000 Rodez<br />
                Aveyron, France
              </p>
            </div>
          </div>
          
          <div className="flex items-start group">
            <div className="w-12 h-12 rounded-xl bg-white/20 flex items-center justify-center mr-4 flex-shrink-0 group-hover:bg-white/30 transition-colors">
              <Phone className="h-5 w-5 text-white" />
            </div>
            <div>
              <h3 className="font-heading font-semibold mb-1">Téléphone</h3>
              <a 
                href="tel:0565678205"
                className="text-white/90 hover:text-white transition-colors font-medium"
              >
                05.65.67.82.05
              </a>
            </div>
          </div>
          
          <div className="flex items-start group">
            <div className="w-12 h-12 rounded-xl bg-white/20 flex items-center justify-center mr-4 flex-shrink-0 group-hover:bg-white/30 transition-colors">
              <Mail className="h-5 w-5 text-white" />
            </div>
            <div>
              <h3 className="font-heading font-semibold mb-1">Email</h3>
              <a 
                href="mailto:contactgfe@groupefabre.com"
                className="text-white/90 hover:text-white transition-colors"
              >
                contactgfe@groupefabre.com
              </a>
            </div>
          </div>
          
          <div className="flex items-start group">
            <div className="w-12 h-12 rounded-xl bg-white/20 flex items-center justify-center mr-4 flex-shrink-0 group-hover:bg-white/30 transition-colors">
              <Clock className="h-5 w-5 text-white" />
            </div>
            <div>
              <h3 className="font-heading font-semibold mb-1">Horaires</h3>
              <p className="text-white/90 leading-relaxed">
                Lundi - Vendredi: 8h00 - 18h00<br />
                Dimanche: Fermé
              </p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Stats cards */}
      <div className="grid grid-cols-2 gap-4">
        <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-2xl font-bold text-fabre-green">9</p>
              <p className="text-sm text-gray-600">Zones d'expertise</p>
            </div>
            <MapPin className="h-8 w-8 text-fabre-green/30" />
          </div>
        </div>
        <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-2xl font-bold text-fabre-green">48h</p>
              <p className="text-sm text-gray-600">Délai d'intervention</p>
            </div>
            <Clock className="h-8 w-8 text-fabre-green/30" />
          </div>
        </div>
      </div>
      
      <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
        <div className="flex items-center mb-6">
          <Award className="h-6 w-6 text-fabre-green mr-3" />
          <h3 className="font-heading font-semibold text-fabre-gray">Nos Sites</h3>
        </div>
        <p className="text-gray-600 mb-6 leading-relaxed">
          Groupe Fabre Environnement dispose de plusieurs sites stratégiquement implantés dans la région. 
          Découvrez le site le plus proche de chez vous pour un service de proximité.
        </p>
        <Button asChild className="bg-fabre-green hover:bg-fabre-darkgreen text-white shadow-lg hover:shadow-xl transition-all">
          <Link to="/sites" className="flex items-center">
            <MapPin className="h-4 w-4 mr-2" />
            Découvrir nos sites
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default ContactInfo;
